import { Alert, IconButton, Snackbar, Typography } from '@mui/joy'
import { type FC, type MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { TbX } from 'react-icons/tb'

import Spinner from '../../ui/Spinner/Spinner'
import { SNACKBAR_SX } from './snackbarSx'
import { type NotificationViewProps } from './types'

const SURFACE = '#171a1c'
const INK = '#ffffff'
const INDICATOR_SIZE = 24

const ProgressSnackbar: FC<NotificationViewProps> = ({ notification, onClose, ...props }) => {
  const { t } = useTranslation()

  return (
    <Snackbar
      {...props}
      onClose={onClose}
      variant="soft"
      sx={SNACKBAR_SX}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={notification.extra?.delay ?? null}
    >
      <Alert
        variant="solid"
        sx={{
          width: '100%',
          gap: 1.25,
          p: 1.5,
          borderRadius: 'sm',
          bgcolor: SURFACE,
          color: INK,
        }}
        startDecorator={
          <Spinner width={INDICATOR_SIZE} height={INDICATOR_SIZE} role="progressbar" />
        }
        endDecorator={
          <IconButton
            variant="plain"
            size="sm"
            aria-label={t('notifications.close')}
            sx={{ color: INK, '--IconButton-size': `${INDICATOR_SIZE}px` }}
            onClick={(event: MouseEvent<HTMLElement>) => {
              onClose?.(event, 'escapeKeyDown')
            }}
          >
            <TbX size={20} />
          </IconButton>
        }
      >
        <Typography level="body-sm" sx={{ color: INK, fontWeight: 500 }}>
          {notification.message}
        </Typography>
      </Alert>
    </Snackbar>
  )
}

export default ProgressSnackbar
